export default __webpack_public_path__ + "js/components/loggedout/parent-creation/teacher-suspected-popup/parent-image-da485070a61058c1354856d91d99660d.svg";